import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "@xstate/react";
import { createMachine } from "xstate";

import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const addSerialNoContext = React.createContext({});
export let addSerialNoMachine: any;

const MODULE_NAME = "machines.addSerialNo";
const log: any = LoggerModule?.getInstance();

export const useSMAddSerialNo = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  addSerialNoMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(addSerialNoMachine);

  return {
    addSerialNoMachine: addSerialNoMachine,
    addSerialNoState: state,
    addSerialNoSend: send,
  };
};
